import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const RECENT_SALES = [{
  name: 'María'
}, {
  name: 'Juan'
}, {
  name: 'Ana'
}, {
  name: 'Carlos'
}, {
  name: 'Sofía'
}, {
  name: 'Laura'
}, {
  name: 'Diego'
}, {
  name: 'Valentina'
}];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(RECENT_SALES[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through sales every 15 seconds
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * RECENT_SALES.length);
        setCurrentSale(RECENT_SALES[randomIndex]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4 border-l-4 border-green-500 max-w-xs" data-id="element-2">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
          <CheckCircle className="w-6 h-6 text-green-600" aria-hidden="true" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-bold text-gray-800" data-id="element-6">
            {currentSale.name} compró el Megapack hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}